export const SAVE_COMPANYADDINFO_STARTED = "SAVE_COMPANYADDINFO_STARTED";
export const SAVE_COMPANYADDINFO_SUCESS = "SAVE_COMPANYADDINFO_SUCESS";
export const SAVE_COMPANYADDINFO_FAILED = "SAVE_COMPANYADDINFO_FAILED";

export const GET_COMPANYADDINFO_STARTED = "GET_COMPANYADDINFO_STARTED";
export const GET_COMPANYADDINFO_SUCESS = "GET_COMPANYADDINFO_SUCESS";
export const GET_COMPANYADDINFO_FAILED = "GET_COMPANYADDINFO_FAILED";

export const ADD_COMPANYADDINFO_STARTED = "ADD_COMPANYADDINFO_STARTED";
export const ADD_COMPANYADDINFO_SUCESS = "ADD_COMPANYADDINFO_SUCESS";
export const ADD_COMPANYADDINFO_FAILED = "ADD_COMPANYADDINFO_FAILED";

export const ADD_LAWFIRM_STARTED = "ADD_LAWFIRM_STARTED";
export const ADD_LAWFIRM_SUCESS = "ADD_LAWFIRM_SUCESS";
export const ADD_LAWFIRM_FAILED = "ADD_LAWFIRM_FAILED";

export const GET_LAWFIRM_STARTED = "GET_LAWFIRM_STARTED";
export const GET_LAWFIRM_SUCESS = "GET_LAWFIRM_SUCESS";
export const GET_LAWFIRM_FAILED = "GET_LAWFIRM_FAILED";

export const UPDATE_LAWFIRM_STARTED = "UPDATE_LAWFIRM_STARTED";
export const UPDATE_LAWFIRM_SUCESS = "UPDATE_LAWFIRM_SUCESS";
export const UPDATE_LAWFIRM_FAILED = "UPDATE_LAWFIRM_FAILED";


export const ADD_ATTORNEY_STARTED = "ADD_ATTORNEY_STARTED";
export const ADD_ATTORNEY_SUCESS = "ADD_ATTORNEY_SUCESS";
export const ADD_ATTORNEY_FAILED = "ADD_ATTORNEY_FAILED";

export const GET_ATTORNEY_STARTED = "GET_ATTORNEY_STARTED";
export const GET_ATTORNEY_SUCESS = "GET_ATTORNEY_SUCESS";
export const GET_ATTORNEY_FAILED = "GET_ATTORNEY_FAILED";

export const UPDATE_ATTORNEY_STARTED = "UPDATE_ATTORNEY_STARTED";
export const UPDATE_ATTORNEY_SUCESS = "UPDATE_ATTORNEY_SUCESS";
export const UPDATE_ATTORNEY_FAILED = "UPDATE_ATTORNEY_FAILED";

export const UPDATE_CORPORATE_STARTED = "UPDATE_CORPORATE_STARTED";
export const UPDATE_CORPORATE_SUCESS = "UPDATE_CORPORATE_SUCESS";
export const UPDATE_CORPORATE_FAILED = "UPDATE_CORPORATE_FAILED";

export const GET_CORPORATE_STARTED = "GET_CORPORATE_STARTED";
export const GET_CORPORATE_SUCESS = "GET_CORPORATE_SUCESS";
export const GET_CORPORATE_FAILED = "GET_CORPORATE_FAILED";

export const ADD_CORPORATE_STARTED = "ADD_CORPORATE_STARTED";
export const ADD_CORPORATE_SUCESS = "ADD_CORPORATE_SUCESS";
export const ADD_CORPORATE_FAILED = "ADD_CORPORATE_FAILED";


export interface IAddCorporates {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const saveCompanyAdditionalDetails = (CompanyAdditionalDetailsInput: any) => {
   // alert("Action");
    //alert(JSON.stringify(CompanyAdditionalDetailsInput));
    return {
        type: SAVE_COMPANYADDINFO_STARTED,
        payload: 'status',
        input: CompanyAdditionalDetailsInput
    };
};

export const addCompanyDetails = (CompanyAdditionalDetailsInput: any) => {
  
     return {
         type: ADD_COMPANYADDINFO_STARTED,
         payload: 'status',
         input: CompanyAdditionalDetailsInput
     };
 };
export const getallCompanyAdditionalDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_COMPANYADDINFO_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };



 export const addLawFirmDetails = (LawFirmDetailsInput: any) => {
  
    return {
        type: ADD_LAWFIRM_STARTED,
        payload: 'status',
        input: LawFirmDetailsInput
    };
};
 
export const updateLawFirmDetails = (LawFirmDetailsInput: any) => {
  
    return {
        type: UPDATE_LAWFIRM_STARTED,
        payload: 'status',
        input: LawFirmDetailsInput
    };
};
export const getAllLawFirmDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_LAWFIRM_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };

 export const addAttorneyDetails = (AttorneyDetailsInput: any) => {
  
    return {
        type: ADD_ATTORNEY_STARTED,
        payload: 'status',
        input: AttorneyDetailsInput
    };
};
 
export const updateAttorneyDetails = (AttorneyDetailsInput: any) => {
  
    return {
        type: UPDATE_ATTORNEY_STARTED,
        payload: 'status',
        input: AttorneyDetailsInput
    };
};
export const getAllAttorneyDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_ATTORNEY_STARTED ,
         payload: 'Value',
         input:companyId
     };
    };
     export const addCorporateDetails = (CorporateDetailsInput: any) => {
  
        return {
            type: ADD_CORPORATE_STARTED,
            payload: 'status',
            input: CorporateDetailsInput 
        };
    };
     
    export const updateCorporateDetail = (CorporateDetailsInput: any) => {
      
        return {
            type: UPDATE_CORPORATE_STARTED,
            payload: 'status',
            input: CorporateDetailsInput
        };
    };
    export const getAllCorporateDetails = (companyId) => {
        // alert("newid");
         return {
             type: GET_CORPORATE_STARTED ,
             payload: 'Value',
             input:companyId
         };
        };
